module.exports = __webpack_public_path__ + "fonts/Solomon Sans Book.716bfbe.otf";